import { styled } from '@mui/material';
import { Link } from 'react-router-dom';

export const StyledSidebarLogo = styled(Link, { shouldForwardProp: (prop) => prop !== 'folded' })<{
  folded: boolean;
}>(({ theme, folded }) => ({
  height: '24px',
  marginBottom: theme.spacing(7),
  marginTop: theme.spacing(8),
  textAlign: 'center',
  width: '100%',

  '& img': {
    maxHeight: '40px',
    maxWidth: folded ? '60%' : '100%',
  },
}));
